import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const NewEventTypeProvider = withSafeSuspense(lazy(async () => ({
  default: (await import('./new_event_type_provider')).NewEventTypeProvider
})))

export const EditEventTypeProvider = withSafeSuspense(lazy(async () => ({
  default: (await import('./edit_event_type_provider')).EditEventTypeProvider
})))

export const SULEventTypeProvider = withSafeSuspense(lazy(async () => ({
  default: (await import('./sul_event_type_provider')).SULEventTypeProvider
})))
